import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { ReactComponent as SMS } from "../../assets/icons/sms.svg";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import Companies from "../../Components/Home/Company";
import Bills from "../../Components/Payment/Bills";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { getBills } from "../../Screens/Payment/Payment";
import { urls } from "../../Utils/url";
export const CompanyImage = (companyId) => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};

export const getHistory = (setHistory, token, setLoading) => {
  ApiCall(
    "get",
    `${urls.getHistory}`,
    null,
    "getHistory",
    token,
    function (e) {
      setHistory(e.data);
      setLoading(false);
      // window.scrollTo({
      //   top: document.getElementById("paymentsContainer").offsetTop,
      //   behavior: "smooth"
      // });
    },
    function (error) {
      setLoading(false);
    }
  );
};

export const ShareModal = ({ shareURL, setVisible }) => {
  return (
    <div className="LoginContainer">
      <div className="ShareModal">
        <span>برنامه مورد نظر برای اشتراک گذاری را انتخاب نمایید</span>
        <div
          style={{
            width: "80%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <a href={`sms:?&body=${shareURL}`}>
            <SMS />
          </a>
          <TelegramShareButton
            url={shareURL}
            children={<TelegramIcon round={true} />}
          />
          <WhatsappShareButton
            url={shareURL}
            children={<WhatsappIcon round={true} />}
          />
          <EmailShareButton
            url={shareURL}
            children={<EmailIcon round={true} />}
          />
        </div>
        <div
          className="LoginButton DismissBtn"
          onClick={() => setVisible(false)}
        >
          انصراف
        </div>
      </div>
    </div>
  );
};

// export const getBillHistory = (
//   billId,
//   token,
//   setHistoryBill,
//   history,
//   setLoading,
//   billName
// ) => {
//   setLoading(true);
//   document.getElementById("LoadingChart") &&
//     window.scrollTo({
//       top: document.getElementById("LoadingChart").offsetTop,
//       behavior: "smooth",
//     });
//   ApiCall(
//     "get",
//     `${urls.GetBillHistory}${billId}`,
//     null,
//     "GethistoryBills",
//     token,
//     function (e) {
//       const getDate = (bill) => {
//         var date;
//         if (bill.bill_company_id === 1) {
//           date = bill.info.CurrentDate;
//         } else if (bill.bill_company_id === 2) {
//           date = bill.info.CurrentReadingDate;
//         } else if (bill.bill_company_id === 3) {
//           date = bill.info.CurrentReadingDate;
//         } else if (bill.bill_company_id === 4) {
//           date = moment(bill.updated_at).format("jYYYY / jM / jD");
//         } else if (bill.bill_company_id === 5) {
//           date = moment(bill.updated_at).format("jYYYY / jM / jD");
//         }
//         return date;
//       };
//       const pushData = {
//         billId: billName,
//         chartData: e.data
//           .filter((i) => i.end_of_period === 1)
//           .map((i) => {
//             return { amount: i.amount, date: getDate(i) };
//           }),
//         companyId: e.data[0].bill_company_id,
//       };
//       setHistoryBill(pushData);
//       setLoading(false);
//       history.push("/chart");
//     },
//     function (error) {
//       setLoading(false);
//       console.log(error);
//     }
//   );
// };

function PaymentHistory({ token, isLogin }) {
  const [bills, setBills] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [shareURL, setShareURL] = useState(false);
  const [companyId, setCompanyId] = useState(0);
  const [billId, setBillId] = useState();
  const [billName, setBillName] = useState("");
  const [moduleID, setModuleID] = useState("");
  const [billsLoading, setBillsLoading] = useState(true);
  // useEffect(() => {
  //   if (billId && isLogin) {
  //     getBillHistory(
  //       billId,
  //       token,
  //       setChartData,
  //       history,
  //       setLoading,
  //       billName
  //     );
  //   }
  // }, [billId, token]);
  useEffect(() => {
    setBillId("");
    // setHistoryBill("");
    companyId !== 0 &&
      document.getElementById("ChooseBillId") &&
      window.scrollTo({
        top: document.getElementById("ChooseBillId").offsetTop,
        behavior: "smooth",
      });
  }, [companyId]);
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) getBills(setBills, token, setBillsLoading);
    return () => (isSubscribed = false);
  }, [token]);

  const filteredBills =
    bills && bills.filter((i) => i.bill_company_id === companyId);
  const History = useHistory();
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    isLogin && getHistory(setHistory, token, setLoading);
  }, [token]);
  useEffect(() => {
    companyId !== 0 &&
      document.getElementById("HistorySpan") &&
      window.scrollTo({
        top: document.getElementById("HistorySpan").offsetTop,
        behavior: "smooth",
      });
  }, [companyId]);
  const filteredHistory =
    history && history.filter((i) => i.user_bill.bill_company_id === companyId);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text="سوابق پرداخت" />
        {loading && (
          <img
            id="loading"
            className="LoadingImage"
            src={require("../../assets/images/Loading.png")}
          />
        )}
        {!loading && (
          <>
            <h4 className="chooseBillType">
              برای مشاهده سوابق پرداخت نوع قبض را مشخص کنید
            </h4>
            <Companies onClick={setCompanyId} selectedId={companyId} />
          </>
        )}

        {!loading && companyId != 0 && !billsLoading && (
          <>
            <h3 style={{ color: "#ec4d11" }} id="ChooseBillId">
              {filteredBills.length > 0
                ? "لطفا شناسه مورد نظر را انتخاب نمایید"
                : "تا کنون قبضی پرداخت نکرده اید"}
            </h3>
            <Bills
              usage={true}
              bills={filteredBills}
              billsLoading={false}
              onClick={() =>
                History.push({
                  pathname: "SingleBillHistory",
                  state: filteredHistory,
                })
              }
              onClickName={setBillName}
              setModuleID={setModuleID}
            />
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(PaymentHistory);
